webpackJsonp([4],{

/***/ 380:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_pago_exitoso_vue__ = __webpack_require__(566);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd399bf2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_pago_exitoso_vue__ = __webpack_require__(641);
var normalizeComponent = __webpack_require__(130)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_pago_exitoso_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd399bf2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_pago_exitoso_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 387:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-header'
});

/***/ }),

/***/ 390:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function data() {
	return {
		swiperOptions: {
			spaceBetween: 30,
			centeredSlides: true,
			autoplay: {
				delay: 10500,
				disableOnInteraction: true
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev'
			}
		}
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'section-help',
	data: data,
	props: {
		gray: {
			type: Boolean,
			default: false
		}
	}
});

/***/ }),

/***/ 392:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_header_vue__ = __webpack_require__(387);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70ffe485_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_vue__ = __webpack_require__(403);
function injectStyle (ssrContext) {
  __webpack_require__(401)
}
var normalizeComponent = __webpack_require__(130)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-70ffe485"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70ffe485_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 393:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'status',
	props: {
		img: String,
		textOne: String,
		textTwo: String
	}
});

/***/ }),

/***/ 401:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(402);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(379)("5d57f7a4", content, true, {});

/***/ }),

/***/ 402:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(378)(true);
// imports


// module
exports.push([module.i, ".header[data-v-70ffe485]{background:#02979b;color:#fff;font-family:Lato;padding:40px 0 10px}.center[data-v-70ffe485]{text-align:center}.text[data-v-70ffe485]{font-weight:900}", "", {"version":3,"sources":["/opt/build/repo/src/components/pago/app-header.vue"],"names":[],"mappings":"AACA,yBACE,mBAAoB,AACpB,WAAe,AACf,iBAAoB,AACpB,mBAAuB,CACxB,AACD,yBACE,iBAAmB,CACpB,AACD,uBACE,eAAiB,CAClB","file":"app-header.vue","sourcesContent":["\n.header[data-v-70ffe485] {\n  background: #02979b;\n  color: #ffffff;\n  font-family: \"Lato\";\n  padding: 40px 0 10px 0;\n}\n.center[data-v-70ffe485] {\n  text-align: center;\n}\n.text[data-v-70ffe485] {\n  font-weight: 900;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 403:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"center mb-2"},[_c('button',{on:{"click":_vm.goToHome}},[_c('img',{attrs:{"src":(_vm.$S3 + "logo-mibodega-white.png"),"alt":"logo","height":"40"}})])]),_vm._v(" "),_c('p',{staticClass:"center text"},[_vm._v("Mi bodega, tu bodega.")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 436:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_help_vue__ = __webpack_require__(390);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75f306d7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_help_vue__ = __webpack_require__(439);
function injectStyle (ssrContext) {
  __webpack_require__(437)
}
var normalizeComponent = __webpack_require__(130)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-75f306d7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_help_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75f306d7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_help_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 437:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(438);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(379)("5a748fe7", content, true, {});

/***/ }),

/***/ 438:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(378)(true);
// imports


// module
exports.push([module.i, ".section-help[data-v-75f306d7]{margin-top:-70px;padding:180px 7% 92px}.section-help.gray[data-v-75f306d7]{background-color:#fafafa}@media (max-width:934px){.section-help[data-v-75f306d7]{padding:130px 5% 82px}}@media (min-width:1350px){.section-help[data-v-75f306d7]{padding:180px 0 92px}}.section-help .title[data-v-75f306d7]{color:#02979b;font-family:Lato;font-weight:600;text-transform:uppercase}@media (max-width:936px){.section-help .title[data-v-75f306d7]{text-align:center}}.section-help .text[data-v-75f306d7]{font-family:Lato;line-height:27px;width:50%}@media (max-width:936px){.section-help .text[data-v-75f306d7]{width:100%;padding-left:0!important;text-align:center}}.section-help .bold[data-v-75f306d7]{font-family:Lato;font-weight:600}.section-help .wrapper-image[data-v-75f306d7]{height:100%;position:relative;width:100%}@media (max-width:936px){.section-help .wrapper-image[data-v-75f306d7]{display:none}}.section-help .image[data-v-75f306d7]{bottom:0;max-height:100%;max-width:100%;position:absolute}.section-help .wrapper-image-mobile[data-v-75f306d7]{display:none;height:257px}@media (max-width:936px){.section-help .wrapper-image-mobile[data-v-75f306d7]{display:block}}.section-help .image-mobile[data-v-75f306d7]{max-height:100%;max-width:100%}.slider-order[data-v-75f306d7]{font-family:Lato}.slider-order .title[data-v-75f306d7]{color:#085f65;font-size:32px!important;font-weight:600}.slider-order .subtitle[data-v-75f306d7]{font-size:20px!important}.slider-order .bold[data-v-75f306d7]{font-weight:600}.slider-order .wrapper-text[data-v-75f306d7]{background-color:#fff;border-radius:9px;box-shadow:0 2px 19px 0 hsla(0,0%,92%,.5);padding:47px 32px}.slider-order .img-slider[data-v-75f306d7]{height:480px}.slider-order .wrapper-slider-order[data-v-75f306d7]{height:100%;position:relative}@media (max-width:936px){.slider-order .wrapper-slider-order[data-v-75f306d7]{padding-top:65px;height:546px}}.w-50[data-v-75f306d7]{width:50%}@media (max-width:936px){.w-50[data-v-75f306d7]{width:100%}}.w-33[data-v-75f306d7]{max-width:160px;min-width:160px}@media (max-width:934px){.w-33[data-v-75f306d7]{margin-right:0!important}}.wrapper-text-card[data-v-75f306d7]{border-radius:9px;box-shadow:0 2px 19px 0 hsla(0,0%,92%,.5);height:160px;padding:25px 0 14px;text-align:center;width:160px}.btn-section[data-v-75f306d7]{background:#b1dc03;border-radius:9px;color:#fff;font-family:Lato;font-size:18px;font-weight:900;display:inline-block;margin:25px 0 0;padding:15px 0;text-decoration:none;width:227px}@media (max-width:934px){.btn-section[data-v-75f306d7]{margin:21px 0 0}}.text-green[data-v-75f306d7]{color:#02979b;font-family:Lato;font-size:14px;line-height:normal;margin-top:20px;min-height:59px;padding:0}.center[data-v-75f306d7]{text-align:center}.title-help[data-v-75f306d7]{color:#085f65;font-family:Lato;font-size:48px;font-weight:900;line-height:normal;margin-bottom:35px;text-transform:uppercase}@media (max-width:934px){.title-help[data-v-75f306d7]{font-size:29px}}.subtitle-help[data-v-75f306d7]{color:#085f65;font-family:Lato;font-size:18px;font-weight:600;line-height:normal;margin-bottom:52px}.wrapper-mobile[data-v-75f306d7]{justify-content:center}@media (max-width:934px){.wrapper-mobile[data-v-75f306d7]{padding:0}}.center-btn-section[data-v-75f306d7]{padding-right:45px}@media (max-width:934px){.center-btn-section[data-v-75f306d7]{padding-right:0}}.wrapper-titles[data-v-75f306d7]{border-right:2px solid #085f65}@media (max-width:934px){.wrapper-titles[data-v-75f306d7]{border-right:none;text-align:center}}.sub-subtitle-help[data-v-75f306d7]{color:#8f8f8f;font-size:18px;padding:10px 30px}@media (max-width:934px){.sub-subtitle-help[data-v-75f306d7]{text-align:center}}", "", {"version":3,"sources":["/opt/build/repo/src/components/home/section-help.vue"],"names":[],"mappings":"AACA,+BACE,iBAAkB,AAClB,qBAAuB,CACxB,AACD,oCACI,wBAA0B,CAC7B,AACD,yBACA,+BACM,qBAAuB,CAC5B,CACA,AACD,0BACA,+BACM,oBAAsB,CAC3B,CACA,AACD,sCACI,cAAe,AACf,iBAAoB,AACpB,gBAAiB,AACjB,wBAA0B,CAC7B,AACD,yBACA,sCACQ,iBAAmB,CAC1B,CACA,AACD,qCACI,iBAAoB,AACpB,iBAAkB,AAClB,SAAW,CACd,AACD,yBACA,qCACQ,WAAY,AACZ,yBAA6B,AAC7B,iBAAmB,CAC1B,CACA,AACD,qCACI,iBAAoB,AACpB,eAAiB,CACpB,AACD,8CACI,YAAa,AACb,kBAAmB,AACnB,UAAY,CACf,AACD,yBACA,8CACQ,YAAc,CACrB,CACA,AACD,sCACI,SAAU,AACV,gBAAiB,AACjB,eAAgB,AAChB,iBAAmB,CACtB,AACD,qDACI,aAAc,AACd,YAAc,CACjB,AACD,yBACA,qDACQ,aAAe,CACtB,CACA,AACD,6CACI,gBAAiB,AACjB,cAAgB,CACnB,AACD,+BACE,gBAAoB,CACrB,AACD,sCACI,cAAe,AACf,yBAA2B,AAC3B,eAAiB,CACpB,AACD,yCACI,wBAA2B,CAC9B,AACD,qCACI,eAAiB,CACpB,AACD,6CACI,sBAA0B,AAC1B,kBAAmB,AACnB,0CAAkD,AAClD,iBAAmB,CACtB,AACD,2CACI,YAAc,CACjB,AACD,qDACI,YAAa,AACb,iBAAmB,CACtB,AACD,yBACA,qDACQ,iBAAkB,AAClB,YAAc,CACrB,CACA,AACD,uBACE,SAAW,CACZ,AACD,yBACA,uBACM,UAAY,CACjB,CACA,AACD,uBACE,gBAAiB,AACjB,eAAiB,CAClB,AACD,yBACA,uBACM,wBAA6B,CAClC,CACA,AACD,oCACE,kBAAmB,AACnB,0CAAkD,AAClD,aAAc,AACd,oBAAuB,AACvB,kBAAmB,AACnB,WAAa,CACd,AACD,8BACE,mBAAoB,AACpB,kBAAmB,AACnB,WAAe,AACf,iBAAoB,AACpB,eAAgB,AAChB,gBAAiB,AACjB,qBAAsB,AACtB,gBAAiB,AACjB,eAAgB,AAChB,qBAAsB,AACtB,WAAa,CACd,AACD,yBACA,8BACM,eAAqB,CAC1B,CACA,AACD,6BACE,cAAe,AACf,iBAAoB,AACpB,eAAgB,AAChB,mBAAoB,AACpB,gBAAiB,AACjB,gBAAiB,AACjB,SAAa,CACd,AACD,yBACE,iBAAmB,CACpB,AACD,6BACE,cAAe,AACf,iBAAoB,AACpB,eAAgB,AAChB,gBAAiB,AACjB,mBAAoB,AACpB,mBAAoB,AACpB,wBAA0B,CAC3B,AACD,yBACA,6BACM,cAAgB,CACrB,CACA,AACD,gCACE,cAAe,AACf,iBAAoB,AACpB,eAAgB,AAChB,gBAAiB,AACjB,mBAAoB,AACpB,kBAAoB,CACrB,AACD,iCACE,sBAAwB,CACzB,AACD,yBACA,iCACM,SAAa,CAClB,CACA,AACD,qCACE,kBAAoB,CACrB,AACD,yBACA,qCACM,eAAmB,CACxB,CACA,AACD,iCACE,8BAAgC,CACjC,AACD,yBACA,iCACM,kBAAmB,AACnB,iBAAmB,CACxB,CACA,AACD,oCACE,cAAe,AACf,eAAgB,AAChB,iBAAmB,CACpB,AACD,yBACA,oCACM,iBAAmB,CACxB,CACA","file":"section-help.vue","sourcesContent":["\n.section-help[data-v-75f306d7] {\n  margin-top: -70px;\n  padding: 180px 7% 92px;\n}\n.section-help.gray[data-v-75f306d7] {\n    background-color: #fafafa;\n}\n@media (max-width: 934px) {\n.section-help[data-v-75f306d7] {\n      padding: 130px 5% 82px;\n}\n}\n@media (min-width: 1350px) {\n.section-help[data-v-75f306d7] {\n      padding: 180px 0 92px;\n}\n}\n.section-help .title[data-v-75f306d7] {\n    color: #02979b;\n    font-family: \"Lato\";\n    font-weight: 600;\n    text-transform: uppercase;\n}\n@media (max-width: 936px) {\n.section-help .title[data-v-75f306d7] {\n        text-align: center;\n}\n}\n.section-help .text[data-v-75f306d7] {\n    font-family: \"Lato\";\n    line-height: 27px;\n    width: 50%;\n}\n@media (max-width: 936px) {\n.section-help .text[data-v-75f306d7] {\n        width: 100%;\n        padding-left: 0px !important;\n        text-align: center;\n}\n}\n.section-help .bold[data-v-75f306d7] {\n    font-family: \"Lato\";\n    font-weight: 600;\n}\n.section-help .wrapper-image[data-v-75f306d7] {\n    height: 100%;\n    position: relative;\n    width: 100%;\n}\n@media (max-width: 936px) {\n.section-help .wrapper-image[data-v-75f306d7] {\n        display: none;\n}\n}\n.section-help .image[data-v-75f306d7] {\n    bottom: 0;\n    max-height: 100%;\n    max-width: 100%;\n    position: absolute;\n}\n.section-help .wrapper-image-mobile[data-v-75f306d7] {\n    display: none;\n    height: 257px;\n}\n@media (max-width: 936px) {\n.section-help .wrapper-image-mobile[data-v-75f306d7] {\n        display: block;\n}\n}\n.section-help .image-mobile[data-v-75f306d7] {\n    max-height: 100%;\n    max-width: 100%;\n}\n.slider-order[data-v-75f306d7] {\n  font-family: \"Lato\";\n}\n.slider-order .title[data-v-75f306d7] {\n    color: #085f65;\n    font-size: 32px !important;\n    font-weight: 600;\n}\n.slider-order .subtitle[data-v-75f306d7] {\n    font-size: 20px !important;\n}\n.slider-order .bold[data-v-75f306d7] {\n    font-weight: 600;\n}\n.slider-order .wrapper-text[data-v-75f306d7] {\n    background-color: #ffffff;\n    border-radius: 9px;\n    box-shadow: 0 2px 19px 0 rgba(234, 234, 234, 0.5);\n    padding: 47px 32px;\n}\n.slider-order .img-slider[data-v-75f306d7] {\n    height: 480px;\n}\n.slider-order .wrapper-slider-order[data-v-75f306d7] {\n    height: 100%;\n    position: relative;\n}\n@media (max-width: 936px) {\n.slider-order .wrapper-slider-order[data-v-75f306d7] {\n        padding-top: 65px;\n        height: 546px;\n}\n}\n.w-50[data-v-75f306d7] {\n  width: 50%;\n}\n@media (max-width: 936px) {\n.w-50[data-v-75f306d7] {\n      width: 100%;\n}\n}\n.w-33[data-v-75f306d7] {\n  max-width: 160px;\n  min-width: 160px;\n}\n@media (max-width: 934px) {\n.w-33[data-v-75f306d7] {\n      margin-right: 0px !important;\n}\n}\n.wrapper-text-card[data-v-75f306d7] {\n  border-radius: 9px;\n  box-shadow: 0 2px 19px 0 rgba(234, 234, 234, 0.5);\n  height: 160px;\n  padding: 25px 0px 14px;\n  text-align: center;\n  width: 160px;\n}\n.btn-section[data-v-75f306d7] {\n  background: #b1dc03;\n  border-radius: 9px;\n  color: #ffffff;\n  font-family: \"Lato\";\n  font-size: 18px;\n  font-weight: 900;\n  display: inline-block;\n  margin: 25px 0 0;\n  padding: 15px 0;\n  text-decoration: none;\n  width: 227px;\n}\n@media (max-width: 934px) {\n.btn-section[data-v-75f306d7] {\n      margin: 21px 0px 0px;\n}\n}\n.text-green[data-v-75f306d7] {\n  color: #02979b;\n  font-family: \"Lato\";\n  font-size: 14px;\n  line-height: normal;\n  margin-top: 20px;\n  min-height: 59px;\n  padding: 0px;\n}\n.center[data-v-75f306d7] {\n  text-align: center;\n}\n.title-help[data-v-75f306d7] {\n  color: #085f65;\n  font-family: \"Lato\";\n  font-size: 48px;\n  font-weight: 900;\n  line-height: normal;\n  margin-bottom: 35px;\n  text-transform: uppercase;\n}\n@media (max-width: 934px) {\n.title-help[data-v-75f306d7] {\n      font-size: 29px;\n}\n}\n.subtitle-help[data-v-75f306d7] {\n  color: #085f65;\n  font-family: \"Lato\";\n  font-size: 18px;\n  font-weight: 600;\n  line-height: normal;\n  margin-bottom: 52px;\n}\n.wrapper-mobile[data-v-75f306d7] {\n  justify-content: center;\n}\n@media (max-width: 934px) {\n.wrapper-mobile[data-v-75f306d7] {\n      padding: 0px;\n}\n}\n.center-btn-section[data-v-75f306d7] {\n  padding-right: 45px;\n}\n@media (max-width: 934px) {\n.center-btn-section[data-v-75f306d7] {\n      padding-right: 0px;\n}\n}\n.wrapper-titles[data-v-75f306d7] {\n  border-right: 2px solid #085f65;\n}\n@media (max-width: 934px) {\n.wrapper-titles[data-v-75f306d7] {\n      border-right: none;\n      text-align: center;\n}\n}\n.sub-subtitle-help[data-v-75f306d7] {\n  color: #8f8f8f;\n  font-size: 18px;\n  padding: 10px 30px;\n}\n@media (max-width: 934px) {\n.sub-subtitle-help[data-v-75f306d7] {\n      text-align: center;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 439:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"section-help container",class:{'gray': _vm.gray},attrs:{"wrap":"","id":"help"}},[_c('v-flex',{attrs:{"xs12":"","mb-5":""}},[_c('v-layout',{attrs:{"wrap":"","justify-center":""}},[_c('v-flex',{staticClass:"wrapper-titles",attrs:{"xs12":"","md4":"","lg3":""}},[_c('p',{staticClass:"mb-0 subtitle-help"},[_vm._v("TE PRESENTAMOS A NUESTRA APP")]),_vm._v(" "),_c('p',{staticClass:"mb-0 title-help"},[_vm._v("BENEFICIOS")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('p',{staticClass:"mb-0 sub-subtitle-help"},[_vm._v("Permitirás a clientes de siempre, hacer sus pedidos desde la comodidad de su casa, de manera segura y sin colas.")])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md7":"","lg6":""}},[_c('v-layout',{staticClass:"wrapper-mobile",attrs:{"wrap":""}},[_c('v-flex',{staticClass:"w-33 mr-2 mb-1"},[_c('div',{staticClass:"wrapper-text-card"},[_c('img',{attrs:{"src":(_vm.$S3 + "card-icon-1.png"),"alt":"fidelizar","height":"38"}}),_vm._v(" "),_c('p',{staticClass:"center text-green"},[_vm._v("Fidelizar a "),_c('br'),_vm._v("tus clientes")])])]),_vm._v(" "),_c('v-flex',{staticClass:"w-33 mr-2 mb-1"},[_c('div',{staticClass:"wrapper-text-card"},[_c('img',{attrs:{"src":(_vm.$S3 + "card-icon-10.svg"),"alt":"crédito","height":"38"}}),_vm._v(" "),_c('p',{staticClass:"center text-green"},[_vm._v("Incrementar"),_c('br'),_vm._v("tus ventas")])])]),_vm._v(" "),_c('v-flex',{staticClass:"w-33 mr-2 mb-1"},[_c('div',{staticClass:"wrapper-text-card"},[_c('img',{attrs:{"src":(_vm.$S3 + "card-icon-11.svg"),"alt":"pago en línea","height":"38"}}),_vm._v(" "),_c('p',{staticClass:"center text-green"},[_vm._v("Facilitar a tus clientes"),_c('br'),_vm._v("con todos los medios"),_c('br'),_vm._v("de pago.")])])]),_vm._v(" "),_c('v-flex',{staticClass:"w-33 mr-2 mb-1"},[_c('div',{staticClass:"wrapper-text-card"},[_c('img',{attrs:{"src":(_vm.$S3 + "card-icon-4.png"),"alt":"ganar tiempo","height":"38"}}),_vm._v(" "),_c('p',{staticClass:"center text-green"},[_vm._v("Gestionar tus pedidos"),_c('br'),_vm._v("de manera más rápida y "),_c('br'),_vm._v("organizada")])])]),_vm._v(" "),_c('v-flex',{staticClass:"w-33 mr-2 mb-1"},[_c('div',{staticClass:"wrapper-text-card"},[_c('img',{attrs:{"src":(_vm.$S3 + "card-icon-16.svg"),"alt":"ganar tiempo","height":"38"}}),_vm._v(" "),_c('p',{staticClass:"center text-green"},[_vm._v("Contar con un listado"),_c('br'),_vm._v("de datos de productos"),_c('br'),_vm._v("con imágenes")])])]),_vm._v(" "),_c('v-flex',{staticClass:"w-33 mr-2 mb-1"},[_c('div',{staticClass:"wrapper-text-card"},[_c('img',{attrs:{"src":(_vm.$S3 + "card-icon-13.svg"),"alt":"programar compras","height":"38"}}),_vm._v(" "),_c('p',{staticClass:"center text-green"},[_vm._v("Manejar de"),_c('br'),_vm._v("manera más"),_c('br'),_vm._v("eficiente tu stock")])])]),_vm._v(" "),(!_vm.isPeru)?_c('v-flex',{staticClass:"w-33 mr-2 mb-1"},[_c('div',{staticClass:"wrapper-text-card"},[_c('img',{attrs:{"src":(_vm.$S3 + "card-icon-14.svg"),"alt":"manejar stock","height":"38"}}),_vm._v(" "),_c('p',{staticClass:"center text-green"},[_vm._v("Hacer "),_c('br'),_vm._v("facturas "),_c('br'),_vm._v("electrónicas.")])])]):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"w-33 mr-2 mb-1"},[_c('div',{staticClass:"wrapper-text-card"},[_c('img',{attrs:{"src":(_vm.$S3 + "card-icon-12.svg"),"alt":"ofertas","height":"38"}}),_vm._v(" "),_c('p',{staticClass:"center text-green"},[_vm._v("Ofertar productos de"),_c('br'),_vm._v("mayor rotación y antes"),_c('br'),_vm._v("de que caduquen.")])])]),_vm._v(" "),_c('v-flex',{staticClass:"w-33 mr-2 mb-1"},[_c('div',{staticClass:"wrapper-text-card"},[_c('img',{attrs:{"src":(_vm.$S3 + "card-icon-15.svg"),"alt":"ganar tiempo","height":"38"}}),_vm._v(" "),_c('p',{staticClass:"center text-green"},[_vm._v(" Cuidar a tus vecinos y "),_c('br'),_vm._v("a ti mismo, ayudando al "),_c('br'),_vm._v("aislamiento social.")])])])],1),_vm._v(" "),(_vm.$route.name === 'page-home')?_c('div',{staticClass:"center center-btn-section"},[_c('a',{staticClass:"btn-section bold",attrs:{"href":"#banner"}},[_vm._v("Solicita tu app")])]):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"slider-order",attrs:{"xs12":"","md5":"","lg6":"","pl-3":""}},[_c('div',{staticClass:"wrapper-slider-order"},[_c('slider',{attrs:{"animation":"fade","speed":2000,"height":"100%"}},[_c('slider-item',[_c('div',{staticClass:"center"},[_c('img',{staticClass:"img-slider",attrs:{"src":"https://makiperesel-landing.s3-sa-east-1.amazonaws.com/Imagenes/slide1-min.png","alt":"slide-1"}})])]),_vm._v(" "),_c('slider-item',[_c('div',{staticClass:"center"},[_c('img',{staticClass:"img-slider",attrs:{"src":(_vm.$S3 + "slide-image-2-min.png"),"alt":"slider-2"}})])]),_vm._v(" "),_c('slider-item',[_c('div',{staticClass:"center"},[_c('img',{staticClass:"img-slider",attrs:{"src":(_vm.$S3 + "slide-image-3-min.png"),"alt":"slider-3"}})])])],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 444:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_status_vue__ = __webpack_require__(393);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7424ea21_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_status_vue__ = __webpack_require__(447);
function injectStyle (ssrContext) {
  __webpack_require__(445)
}
var normalizeComponent = __webpack_require__(130)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7424ea21"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_status_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7424ea21_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_status_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 445:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(446);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(379)("641855c3", content, true, {});

/***/ }),

/***/ 446:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(378)(true);
// imports


// module
exports.push([module.i, ".center[data-v-7424ea21]{text-align:center}.wrapper-status[data-v-7424ea21]{color:#8f8f8f;font-weight:900;font-size:25px;padding:85px 0}.text-green[data-v-7424ea21]{color:#02979b;font-size:28px}", "", {"version":3,"sources":["/opt/build/repo/src/components/pago/status.vue"],"names":[],"mappings":"AACA,yBACE,iBAAmB,CACpB,AACD,iCACE,cAAe,AACf,gBAAiB,AACjB,eAAgB,AAChB,cAAgB,CACjB,AACD,6BACE,cAAe,AACf,cAAgB,CACjB","file":"status.vue","sourcesContent":["\n.center[data-v-7424ea21] {\n  text-align: center;\n}\n.wrapper-status[data-v-7424ea21] {\n  color: #8f8f8f;\n  font-weight: 900;\n  font-size: 25px;\n  padding: 85px 0;\n}\n.text-green[data-v-7424ea21] {\n  color: #02979b;\n  font-size: 28px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 447:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper-status"},[_c('div',{staticClass:"center mb-4"},[_c('img',{attrs:{"src":_vm.img,"alt":"imagen","height":"68"}})]),_vm._v(" "),_c('p',{staticClass:"center"},[_c('span',{staticClass:"text-green"},[_vm._v("TU PAGO")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.textOne))]),_vm._v(" "),_c('span',{staticClass:"text-green"},[_vm._v(_vm._s(_vm.textTwo))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 448:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'footer-pago'
});

/***/ }),

/***/ 547:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_pago_vue__ = __webpack_require__(448);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3454455f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_pago_vue__ = __webpack_require__(550);
function injectStyle (ssrContext) {
  __webpack_require__(548)
}
var normalizeComponent = __webpack_require__(130)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3454455f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_pago_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3454455f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_pago_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 548:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(549);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(379)("b9f760e6", content, true, {});

/***/ }),

/***/ 549:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(378)(true);
// imports


// module
exports.push([module.i, ".image-footer[data-v-3454455f]{background-image:url(\"https://mibodega.s3-sa-east-1.amazonaws.com/footer-pago.png\");background-size:cover;background-position:top;height:492px;padding-top:30%;width:100%}@media (max-width:959px){.image-footer[data-v-3454455f]{height:252px;padding-top:15%}}.footer-text[data-v-3454455f]{background-color:#fff;border-radius:17px;color:#02979b;font-size:20px;font-weight:900;margin:0 auto;opacity:.65;padding:33px;width:372px}.wrapper-logo[data-v-3454455f]{border-bottom:4px solid #b1dc03;padding:30px 6% 30px 0;text-align:right}@media (max-width:959px){.wrapper-logo[data-v-3454455f]{text-align:center}}.wrapper-info[data-v-3454455f]{padding:10% 6% 0 0;text-align:right}.footer-end[data-v-3454455f]{background:#b1dc03;bottom:0;color:#fff;font-family:Lato;font-size:16px;font-weight:900;padding:14px 0;text-align:center}.footer-info[data-v-3454455f]{color:#02979b;font-size:16px}.name-country[data-v-3454455f]{font-family:Lato;font-weight:600;font-size:24px}.direction[data-v-3454455f]{color:#02979b;text-decoration:none}.link[data-v-3454455f]{color:#fff;text-decoration:none}", "", {"version":3,"sources":["/opt/build/repo/src/components/pago/footer-pago.vue"],"names":[],"mappings":"AACA,+BACE,oFAAqF,AACrF,sBAAuB,AACvB,wBAAyB,AACzB,aAAc,AACd,gBAAiB,AACjB,UAAY,CACb,AACD,yBACA,+BACM,aAAc,AACd,eAAiB,CACtB,CACA,AACD,8BACE,sBAA0B,AAC1B,mBAAoB,AACpB,cAAe,AACf,eAAgB,AAChB,gBAAiB,AACjB,cAAe,AACf,YAAc,AACd,aAAc,AACd,WAAa,CACd,AACD,+BACE,gCAAiC,AACjC,uBAAwB,AACxB,gBAAkB,CACnB,AACD,yBACA,+BACM,iBAAmB,CACxB,CACA,AACD,+BACE,mBAAoB,AACpB,gBAAkB,CACnB,AACD,6BACE,mBAAoB,AACpB,SAAU,AACV,WAAe,AACf,iBAAoB,AACpB,eAAgB,AAChB,gBAAiB,AACjB,eAAgB,AAChB,iBAAmB,CACpB,AACD,8BACE,cAAe,AACf,cAAgB,CACjB,AACD,+BACE,iBAAoB,AACpB,gBAAiB,AACjB,cAAgB,CACjB,AACD,4BACE,cAAe,AACf,oBAAsB,CACvB,AACD,uBACE,WAAe,AACf,oBAAsB,CACvB","file":"footer-pago.vue","sourcesContent":["\n.image-footer[data-v-3454455f] {\n  background-image: url(\"https://mibodega.s3-sa-east-1.amazonaws.com/footer-pago.png\");\n  background-size: cover;\n  background-position: top;\n  height: 492px;\n  padding-top: 30%;\n  width: 100%;\n}\n@media (max-width: 959px) {\n.image-footer[data-v-3454455f] {\n      height: 252px;\n      padding-top: 15%;\n}\n}\n.footer-text[data-v-3454455f] {\n  background-color: #ffffff;\n  border-radius: 17px;\n  color: #02979b;\n  font-size: 20px;\n  font-weight: 900;\n  margin: 0 auto;\n  opacity: 0.65;\n  padding: 33px;\n  width: 372px;\n}\n.wrapper-logo[data-v-3454455f] {\n  border-bottom: 4px solid #b1dc03;\n  padding: 30px 6% 30px 0;\n  text-align: right;\n}\n@media (max-width: 959px) {\n.wrapper-logo[data-v-3454455f] {\n      text-align: center;\n}\n}\n.wrapper-info[data-v-3454455f] {\n  padding: 10% 6% 0 0;\n  text-align: right;\n}\n.footer-end[data-v-3454455f] {\n  background: #b1dc03;\n  bottom: 0;\n  color: #ffffff;\n  font-family: \"Lato\";\n  font-size: 16px;\n  font-weight: 900;\n  padding: 14px 0;\n  text-align: center;\n}\n.footer-info[data-v-3454455f] {\n  color: #02979b;\n  font-size: 16px;\n}\n.name-country[data-v-3454455f] {\n  font-family: \"Lato\";\n  font-weight: 600;\n  font-size: 24px;\n}\n.direction[data-v-3454455f] {\n  color: #02979b;\n  text-decoration: none;\n}\n.link[data-v-3454455f] {\n  color: #ffffff;\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 550:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"wrapper-logo"},[_c('img',{attrs:{"src":(_vm.$S3 + "logo-mibodega-green.png"),"alt":"logo"}})])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md7":""}},[_c('div',{staticClass:"image-footer"},[_c('div',{staticClass:"footer-text"},[_vm._v("NUESTROS CANALES DE "),_c('br'),_vm._v(" CONTACTO OFICIALES")])])]),_vm._v(" "),_c('v-flex',{staticClass:"wrapper-info",attrs:{"xs12":"","md5":""}},[_c('div',{staticClass:"footer-info"},[_c('p',{staticClass:"name-country"},[_vm._v("Perú")]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('a',{staticClass:"mb-0 direction",attrs:{"href":"https://goo.gl/maps/8vAGxHq1v49WAxj26","target":"_blank"}},[_vm._v("\n\t\t\t\t\tLima\n\t\t\t\t")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("+51 940 637 220")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("Calle Independencia  106,  Piso 10")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("Miraflores")])])]),_vm._v(" "),_c('div',[_c('a',{staticClass:"mr-3",attrs:{"href":"https://www.facebook.com/Mi-bodega--107633674246248/?modal=admin_todo_tour","target":"_blank"}},[_c('img',{attrs:{"src":(_vm.$S3 + "facebook-logo.png"),"alt":"facebook","height":"30px"}})]),_vm._v(" "),_c('a',{attrs:{"href":"https://www.instagram.com/mibodegape/","target":"_blank"}},[_c('img',{attrs:{"src":(_vm.$S3 + "instagram-logo.png"),"alt":"instagram","height":"30px"}})])])]),_vm._v(" "),_c('v-flex',{staticClass:"footer-end",attrs:{"xs12":""}},[_c('p',{staticClass:"mb-0"},[_vm._v("Derechos reservados  "),_c('a',{staticClass:"link",attrs:{"href":"https://www.makipos.la","target":"_blank"}},[_vm._v("makipos.la")]),_vm._v(" | Desarrollado por apprunn")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 566:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pago_app_header__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pago_status__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home_section_help__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pago_footer_pago__ = __webpack_require__(547);
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-pago-exitoso',
	components: {
		headerPago: __WEBPACK_IMPORTED_MODULE_0__components_pago_app_header__["a" /* default */],
		status: __WEBPACK_IMPORTED_MODULE_1__components_pago_status__["a" /* default */],
		sectionHelp: __WEBPACK_IMPORTED_MODULE_2__components_home_section_help__["a" /* default */],
		footerPago: __WEBPACK_IMPORTED_MODULE_3__components_pago_footer_pago__["a" /* default */]
	}
});

/***/ }),

/***/ 641:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header-pago'),_vm._v(" "),_c('status',{attrs:{"img":(_vm.$S3 + "checked-1.svg"),"text-one":"FUE REALIZADO","text-two":"CON ÉXITO"}}),_vm._v(" "),_c('section-help'),_vm._v(" "),_c('footer-pago')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/4.78d99d9a58319105ed9e.js